import { Box } from "@mui/material";
import { clientLogos } from "../assets";


function PartnersGrid() {
    return (
        <Box component="section" sx={{ backgroundColor: "#ECEDF8" }}>
            <Box
                sx={{
                    width: { xs: "100%", lg: "1440px" },
                    mx: "auto",
                    minHeight: { lg: "564px" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    py: { xs: 6, md: 8 },
                }}
            >
                <Box
                    sx={{
                        width: { xs: "100%", lg: "1248px" },
                        minHeight: { lg: "372px" },
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "repeat(2, minmax(120px, 1fr))",
                            sm: "repeat(3, minmax(120px, 1fr))",
                            md: "repeat(4, minmax(140px, 1fr))",
                            lg: "repeat(6, 178px)",
                        },
                        justifyContent: { lg: "space-between" },
                        columnGap: { xs: 3, lg: "36px" },
                        rowGap: { xs: 3, lg: "36px" },
                        px: { xs: 2, sm: 3 },
                    }}
                >
                    {clientLogos.map((src, i) => (
                        <Box
                            key={i}
                            sx={{
                                width: { lg: "178px" },
                                height: { lg: "100px" },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                aspectRatio: { xs: "16 / 9", lg: "auto" },
                            }}
                        >
                            <Box
                                component="img"
                                src={src}
                                alt={`parceiro-${i + 1}`}
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    filter: { xs: "grayscale(100%)", lg: "grayscale(100%)" },
                                    opacity: 0.95,
                                    userSelect: "none",
                                    pointerEvents: "none",
                                }}
                            />
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default PartnersGrid;